import { z } from 'zod';

export const WorkspaceCurrencySchema = z.object({
  urn: z.string(),
  label: z.string(),
  currencySign: z.string(),
  currencyCode: z.string(),
});

export const WorkspaceInfoResponseSchema = z.object({
  name: z.string(),
  firstDate: z.string(),
  currencies: z.array(WorkspaceCurrencySchema),
});
